// Densio — offres, galerie, ajout au panier (copie adaptée de bar.js).
import { CartLinesUpdateEvent } from '@shopify/events';

const root = document.querySelector('[data-bar]');
if (root) {
  const variants = JSON.parse(root.dataset.variants || '[]');
  const fmt = root.dataset.moneyFormat || '{{amount_with_comma_separator}} €';
  const iOffre = root.dataset.offreIndex === '' ? -1 : Number(root.dataset.offreIndex);
  const iCouleur = root.dataset.couleurIndex === '' ? -1 : Number(root.dataset.couleurIndex);
  const offres = [...root.querySelectorAll('[data-offre]')];
  const pastilles = [...root.querySelectorAll('[data-couleur]')];
  const err = root.querySelector('[data-erreur]');

  const money = (cents) => {
    const v = (cents / 100).toFixed(2);
    const [e, d] = v.split('.');
    const comma = e.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + d;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === 'amount' ? e.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + d
      : k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator' ? e
      : comma);
  };

  const state = {
    offre: (offres.find((o) => o.classList.contains('on')) || offres[0])?.dataset.offre,
    couleur: pastilles[0]?.dataset.couleur,
  };

  const find = (offre, couleur) =>
    variants.find((v) => (iOffre < 0 || v.o[iOffre] === offre) && (iCouleur < 0 || v.o[iCouleur] === couleur)) || variants[0];

  const render = () => {
    offres.forEach((o) => {
      const v = find(o.dataset.offre, state.couleur);
      const on = o.dataset.offre === state.offre;
      o.classList.toggle('on', on);
      o.setAttribute('aria-checked', on);
      if (!v) return;
      o.querySelector('[data-offre-prix]').textContent = money(v.price);
      const s = o.querySelector('[data-offre-barre]');
      s.textContent = v.compare > v.price ? money(v.compare) : '';
      const pc = o.querySelector('[data-offre-pct]');
      if (pc) pc.textContent = v.compare > v.price ? '-' + Math.round((1 - v.price / v.compare) * 100) + ' %' : '';
    });
    pastilles.forEach((p) => {
      const on = p.dataset.couleur === state.couleur;
      p.classList.toggle('on', on);
      p.setAttribute('aria-pressed', on);
    });
    pastilles.forEach((p) => p.classList.toggle('rupture', !variants.some((x) => (iCouleur < 0 || x.o[iCouleur] === p.dataset.couleur) && x.available)));
    const v = find(state.offre, state.couleur);
    const dispo = variants.length === 0 ? true : (!!v && v.available);
    const nom = root.querySelector('[data-couleur-nom]');
    if (nom && state.couleur) nom.textContent = state.couleur + (dispo ? '' : ' · bientôt de retour');
    root.querySelectorAll('[data-prix]').forEach((el) => (el.textContent = v ? money(v.price) : ''));
    root.querySelectorAll('[data-add]').forEach((b) => {
      if (!b.dataset.html) b.dataset.html = b.innerHTML;
      b.disabled = !dispo;
      if (dispo) { if (b.innerHTML !== b.dataset.html) { b.innerHTML = b.dataset.html; b.querySelectorAll('[data-prix]').forEach((el) => (el.textContent = money(v.price))); } }
      else b.textContent = 'Bientôt de retour';
    });
  };

  offres.forEach((o) => o.addEventListener('click', () => { state.offre = o.dataset.offre; render(); }));
  pastilles.forEach((p) => p.addEventListener('click', () => { state.couleur = p.dataset.couleur; render(); }));

  // Galerie
  const main = root.querySelector('[data-gal-main]');
  const thumbs = [...root.querySelectorAll('[data-thumb]')];
  const count = root.querySelector('[data-gal-count]');
  let cur = 0;
  const show = (i) => {
    if (!thumbs.length || !main) return;
    cur = (i + thumbs.length) % thumbs.length;
    thumbs.forEach((x, k) => x.classList.toggle('on', k === cur));
    main.removeAttribute('srcset'); main.src = thumbs[cur].dataset.full;
    if (count) count.textContent = (cur + 1) + ' / ' + thumbs.length;
    thumbs[cur].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  };
  if (count && thumbs.length) count.textContent = '1 / ' + thumbs.length;
  thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
  root.querySelector('[data-gal-prev]')?.addEventListener('click', () => show(cur - 1));
  root.querySelector('[data-gal-next]')?.addEventListener('click', () => show(cur + 1));
  const zone = root.querySelector('[data-gal-zone]');
  let x0 = null;
  zone?.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
  zone?.addEventListener('touchend', (e) => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
  });
  // précharge les images du carrousel après le chargement de la page
  window.addEventListener('load', () => setTimeout(() => thumbs.slice(1).forEach((t) => { const im = new Image(); im.src = t.dataset.full; }), 1500));

  // Bouton « offrir » : remonte aux offres et choisit 2 kits
  root.querySelector('[data-goto-offres]')?.addEventListener('click', (e) => {
    e.preventDefault();
    if (offres[1]) { state.offre = offres[1].dataset.offre; render(); }
    root.querySelector('.bar-offres')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  // Ajout au panier
  const add = async (btn) => {
    const v = find(state.offre, state.couleur);
    if (!v) { root.querySelector('.bar-offres')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    btn.setAttribute('aria-busy', 'true');
    if (err) err.hidden = true;
    let resolve, reject;
    const promise = new Promise((a, b) => { resolve = a; reject = b; });
    try {
      document.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: [{ merchandiseId: String(v.id), quantity: 1 }],
        promise,
      }));
    } catch (_) { /* tiroir indisponible : on redirige plus bas */ }
    try {
      const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Erreur');
      const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
      let cartObj = cart;
      try { cartObj = CartLinesUpdateEvent.createCartFromAjaxResponse(cart); } catch (_) {}
      resolve({ cart: cartObj, detail: { items: cart.items, source: 'bar-produit', itemCount: 1 } });
      if (!document.querySelector('cart-drawer-component')) window.location.href = '/cart';
    } catch (e) {
      reject(e);
      if (err) { err.textContent = e.message || 'Oups, réessaie dans un instant.'; err.hidden = false; }
    } finally {
      btn.removeAttribute('aria-busy');
    }
  };
  root.querySelectorAll('[data-add]').forEach((b) => b.addEventListener('click', () => add(b)));

  // Barre collée en bas (téléphone) : visible une fois le bouton principal dépassé
  const sticky = root.querySelector('[data-sticky]');
  const mainBtn = root.querySelector('.bar-info [data-add]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0))
      .observe(mainBtn);
  }

  // Vidéo démo : chargée et lancée seulement quand elle est visible
  const demo = root.querySelector('[data-demo]');
  if (demo && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        const s = demo.querySelector('source[data-src]');
        if (s) { s.src = s.dataset.src; s.removeAttribute('data-src'); demo.load(); }
        demo.play().catch(() => {});
      } else demo.pause();
    }, { threshold: 0.3 }).observe(demo);
  }

  // Minuteur de l'offre : jusqu'à minuit (heure locale)
  const tEl = root.querySelector('[data-timer]');
  if (tEl) {
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const now = new Date(); const end = new Date(now); end.setHours(24, 0, 0, 0);
      let d = Math.max(0, Math.floor((end - now) / 1000));
      tEl.textContent = pad(Math.floor(d / 3600)) + ':' + pad(Math.floor(d % 3600 / 60)) + ':' + pad(d % 60);
    };
    tick(); setInterval(tick, 1000);
  }

  render();
}
